import {
  CommonInputWidgetConfigSchema,
  ConditionGroupExpressionSchema,
  ExpressionRepository,
  ExpressionType,
  getDefaultAssignableExpressionSchema,
} from '@framework/engine';
import { yup } from '@framework/validation';
import {
  IModuleTriggerWidget,
  WidgetModuleTriggerType,
} from './IModuleTriggerWidget';

export const ModuleTriggerConfigSchema: yup.ObjectSchema<IModuleTriggerWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetModuleTriggerType).required(),
    expression: ConditionGroupExpressionSchema.required().label('Espressione'),
    moduleId: yup.string().required().label('Modulo'),
    needUniqueModuleCode: yup
      .boolean()
      .required()
      .default(false)
      .label('Richiede codice univoco del widget'),
    uniqueModuleCode: getDefaultAssignableExpressionSchema(
      ExpressionRepository.get(ExpressionType.Value).schema.getDefault(),
    ),
    title: getDefaultAssignableExpressionSchema(
      ExpressionRepository.get(ExpressionType.Value).schema.getDefault(),
    ),
  })
    // uniqueModuleCode è un Lazy e yup dà problemi di tipo.
    // In questo modo possiamo andare a creare un when sul campo uniqueModuleCode
    // rimuovendolo quando non è necessario.
    .when('.', ([widget]: IModuleTriggerWidget[], schema) => {
      if (!widget) return schema;
      if (widget.needUniqueModuleCode) {
        return schema;
      }
      return schema.shape({
        uniqueModuleCode: yup.object().notRequired().strip(),
      });
    })
    .required()
    .noUnknown();
